angular.module('unergie.main')
.controller('zendeskB2gCommentsModalCtrl', ($scope, $uibModalInstance, AuthService, ApiAdmin, ErrorCatcher, idZendeskB2g, readOnly, BoFeaturesService) => {
    $scope.isComplaintsFeatureOn = (feature) => BoFeaturesService.getModuleFeatures('complaints')[feature]
    $scope.close = () => $uibModalInstance.dismiss()
console.log("coucou");

    $scope.idZendeskB2g = idZendeskB2g
    $scope.readOnly = readOnly
    $scope.newComment = {}

    $scope.isMyComment = (comment) => comment.author.isCallerAuthor

    $scope.refreshComments = () => {
        $scope.refreshingComments = true

        ApiAdmin.getZendeskB2gTicketComments({ id: $scope.idZendeskB2g }).$promise.then((response) => {
            $scope.comments = _.reduce(response.comments, (accComments, comment) => {
                let author = comment.author
                let displayedComment = comment.body


                accComments.push(_.assign({}, comment, {
                    displayedComment,
                    author,
                }))

                return accComments
            }, [])
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshingComments = false
        })
    }

    $scope.refreshComments()


    const addComment = (is_public = true) => {
        if ($scope.postingComment) {
            return
        }
        $scope.postingComment = true
        ApiAdmin.createZendeskB2gTicketComment({ id: $scope.idZendeskB2g }, { comment: $scope.newComment.text, public: is_public }).$promise.then(() => {
            $scope.refreshComments()
            $scope.newComment.text = ''
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.postingComment = false
        })
    }
    $scope.addPublicComment = () => addComment(true)
    $scope.addInternalComment = () => addComment(false)

    $scope.kbconfig = () => ([
        { combo: [17, 13], func: $scope.addPublicComment, data: $scope.newComment },
    ])
})
